module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./PipeHub.js"));
	}, "PipeHub");
}